import { css } from '@emotion/css'
import { spacing, shorthandHelper } from '@offerzen/pinata'

const styles = {
  form: css({
    margin: shorthandHelper([0, -spacing.large, 0, -spacing.large]),
  }),

  fields: css({
    padding: shorthandHelper([0, spacing.large]),
  }),

  field: css({
    width: '100%',

    '& input': {
      border: 0,
      height: '100% !important',
      backgroundColor: 'transparent',
    },
  }),

  notification: css({
    marginBottom: spacing.medium,
  }),

  footer: css({
    marginTop: spacing.large,
  }),
}

export default styles
